import { useStore } from '../../store';
import { PermissionSlug } from '../../constants/featureFlags';

/**
 * Whether this viewer may rule on imported Kinnser chart lines.
 *
 * The frontend half of the three gates — route dependency, this render gate,
 * and a re-check in the CRUD layer that actually writes. The list must be
 * identical to `RECONCILE_PERMISSIONS` in
 * `backend/app/crud/imported_chart_line.py`; a frontend that offers a verb the
 * backend refuses ships an enabled-looking, broken-on-use button.
 *
 * `patient-mgr:access` is the slug behind the Patients navigation, so everyone
 * who can legitimately open a chart already holds it. Super-users short-circuit
 * inside `hasAnyPermission`.
 *
 * Read-only display is deliberately *not* gated. Seeing what the previous EMR
 * held is part of reading the chart; only changing what it becomes is the
 * privileged act.
 */
export function useCanReconcileImports(): boolean {
  const hasAnyPermission = useStore(state => state.hasAnyPermission);
  return hasAnyPermission([
    PermissionSlug.PATIENT_MANAGER,
    PermissionSlug.EMR_MANAGE,
  ]);
}
